import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';

import ChartTitle from '../../ChartTitle/ChartTitle';

import { allTrapsActivityBarChartOptions } from './chartOptions';

import { useAllTrapsActivityBarChartState } from 'hooks/Analitics/MCTCharts/1_allTrapsActivityBarChart/useAllTrapsActivityBarChartState';
import { TrapType } from 'components/AnalyticsPage/TrapType';
import { ObjectTraps } from 'api/analitics/types';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';

interface ChartProps {
  slug: string;
  type: TrapType;
  objectTraps: ObjectTraps;
}

const AllTrapsActivityBarChart: React.FC<ChartProps> = ({ slug, type, objectTraps }) => {
  const [trapType, setTrapType] = useState<TrapType>(type === TrapType.ALL ? TrapType.MCT : type);
  const {
    period,
    startDate,
    endDate,
    showCustom,
    chartData,
    isFetching,
    handlePeriodChange,
    setStartDate,
    setEndDate,
  } = useAllTrapsActivityBarChartState({ slug, trapType });
  const { t } = useTranslation();
  const isMobile = useMediaQuery(MediaBreakpoints.mobile);
  const chartOptions = allTrapsActivityBarChartOptions(chartData, t, isMobile);

  return (
    <div className="card m-0 border border-2 rounded-4 position-relative h-100">
      <div className="card-header rounded-4">
        <ChartTitle
          title={t('ChartsAnalitics.all_traps_activity_chart.title')}
          period={period}
          handlePeriodChange={handlePeriodChange}
          startDate={startDate}
          setStartDate={setStartDate}
          showCustom={showCustom}
          endDate={endDate}
          setEndDate={setEndDate}
          showSwitchTrapType={
            objectTraps.mct.was_ever_installed && objectTraps.smst.was_ever_installed && type !== TrapType.SRST
          }
          switchTrapType={trapType}
          setSwitchTrapType={(value: TrapType) => setTrapType(value)}
          switchTrapTypeLoading={isFetching}
        />
      </div>
      <div className="card-body">
        <div className="position-relative">
          <ReactApexChart options={chartOptions} series={chartOptions.series} type="bar" height={350} />
        </div>
      </div>
    </div>
  );
};

export default AllTrapsActivityBarChart;
